import { Outlet } from 'react-router';
import { Sidebar } from './sidebar';
import { Topbar } from './topbar';

/**
 * Authenticated layout shell — sidebar 240 + topbar 64 + scrollable main.
 * Mounted as a layout route inside <RequireAuth> so unauth users never
 * see the chrome.
 */
export function Shell() {
  return (
    <div className="flex h-screen w-screen overflow-hidden bg-surface-page">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="flex-1 overflow-y-auto px-8 py-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
